"use client";

import { useMemo } from "react";
import { useTranslations } from "next-intl";

export default function LocalDate({ locale, translationKey }) {
    const t = useTranslations();

    const formatted = useMemo(() => {
        return new Date().toLocaleDateString(locale === "fr" ? "fr-FR" : "en-US", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });
    }, [locale]);

    if (translationKey) {
        return t(translationKey, { date: formatted });
    }

    return formatted;
}
